import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import 'bulma/css/bulma.css'
import App from './App.vue'
import router from '@/services/router'; 
import { createPinia } from 'pinia'

/* Import the FontAwesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* Import the icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* Import specific icons */
import { faVolumeUp, faVolumeMute, faPlus, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons'

/* Add icons to the library */
library.add(faVolumeUp, faVolumeMute, faPlus, faTrash, faEdit)

const app = createApp(App)
const pinia = createPinia()
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(pinia) // Register Pinia
app.mount('#app')